import { isAiConversationType } from '@lyrahealth-inc/shared-app-logic/src/features/messaging/utils'
import { ConversationObject } from '@lyrahealth-inc/shared-app-logic/src/models/conversation/Conversation'
import { ProviderPairConversationObject } from '@lyrahealth-inc/shared-app-logic/src/models/conversation/CoordinatedCareConversation'
import { CONVERSATION_TYPE } from '@lyrahealth-inc/shared-app-logic/src/models/messages/Messages'

import { ALL_CONVERSATION_TAGS, RTKQueryTag } from '../../../data/baseApi'

// LyraTherapy stores the conversation type in Twilio attributes.type. Older or
// unrecognized payloads must refresh both lists; missing type is not proof of a patient chat.
export const getConversationAddedTags = (attributes: unknown) => {
  const type = attributes && typeof attributes === 'object' && 'type' in attributes ? attributes.type : undefined
  switch (type) {
    case CONVERSATION_TYPE.PROVIDER_PROVIDER:
      return [RTKQueryTag.PROVIDER_PAIR_CONVERSATION]
    case CONVERSATION_TYPE.PROVIDER:
    case CONVERSATION_TYPE.AI_COACH:
    case CONVERSATION_TYPE.MANAGER_COACHING_AI:
      return [RTKQueryTag.CONVERSATION]
    default:
      return ALL_CONVERSATION_TAGS
  }
}

export const applyMessageAddedToConversation = (
  conversation: ConversationObject,
  messageAuthorId: string | undefined,
  providerId: string,
  messageSentDatetime: string,
) => {
  const attributes = conversation.conversation_attributes
  if (messageAuthorId !== providerId) {
    if (isAiConversationType(attributes.type)) {
      attributes.unread_ai_coach_messages_provider_count = (attributes.unread_ai_coach_messages_provider_count ?? 0) + 1
    } else {
      attributes.unread_provider_messages_count = (attributes.unread_provider_messages_count ?? 0) + 1
    }
  }
  conversation.conversation_last_message_sent_datetime = messageSentDatetime
}

export const applyMessageAddedToProviderPairConversation = (
  conversation: ProviderPairConversationObject,
  messageAuthorId: string | undefined,
  providerId: string,
  messageSentDatetime: string,
) => {
  if (messageAuthorId !== providerId) {
    conversation.current_user.unread_count = (conversation.current_user.unread_count ?? 0) + 1
  }
  conversation.conversation_last_message_sent_datetime = messageSentDatetime
}
